var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.818 17.1364C11.818 16.1614 12.6157 15.3636 13.5907 15.3636H41.9543C42.9293 15.3636 43.7271 14.5659 43.7271 13.5909C43.7271 12.6159 42.9293 11.8182 41.9543 11.8182H11.818C9.86796 11.8182 8.27251 13.4136 8.27251 15.3636V34.8636H7.38614C5.91478 34.8636 4.72705 36.0514 4.72705 37.5227C4.72705 38.9941 5.91478 40.1818 7.38614 40.1818H26.8861C28.3575 40.1818 29.5452 38.9941 29.5452 37.5227C29.5452 36.0514 28.3575 34.8636 26.8861 34.8636H11.818V17.1364ZM45.4998 18.9091H34.8634C33.8884 18.9091 33.0907 19.7068 33.0907 20.6818V38.4091C33.0907 39.3841 33.8884 40.1818 34.8634 40.1818H45.4998C46.4748 40.1818 47.2725 39.3841 47.2725 38.4091V20.6818C47.2725 19.7068 46.4748 18.9091 45.4998 18.9091ZM43.7271 34.8636H36.6361V22.4545H43.7271V34.8636Z",
    fill: "url(#paint0_linear_538_2992)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_2992",
    x1: 4.72705,
    y1: 40.1818,
    x2: 30.9089,
    y2: 0.909083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628533,
    stopColor: "#F23A3A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.b71b55ecb52c55b3586d780408b3269a.svg";
export { ForwardRef as ReactComponent };